import {BACKEND_URL, fetchInit, getMMToken} from '../util/util';
import {TimeRange} from "./types";

export const getStats = async (timeRange: TimeRange, start: number | undefined, end: number | undefined, useUserAgnosticStats: boolean) => {
    const response = await fetch(buildStatsURL(timeRange, start, end, useUserAgnosticStats), fetchInit('stats', null, getMMToken()!));
    if (!response.ok) return Promise.resolve('No tracks found for this time period.');
    return await response.json();
}

export const getTrackStats = async (id: string) => {
    return await getEntityStats(id, 'track');
}

export const getArtistStats = async (id: string) => {
    return await getEntityStats(id, 'artist');
}

export const getAlbumStats = async (id: string) => {
    return await getEntityStats(id, 'album');
}

const getEntityStats = async (id: string, entityType: string) => {
    // entityType must be 'track', 'artist', or 'album' exactly
    const response = await fetch(buildEntityStatsURL(id, entityType), fetchInit('entityStats', null, getMMToken()!));
    if (!response.ok) return Promise.resolve(undefined); // todo: better error handling?
    return await response.json();
}

export const doSearch = async (searchTerm: string) => {
    if (searchTerm === '') return Promise.resolve(undefined);
    const response = await fetch(buildSearchURL(searchTerm), fetchInit('search', null, getMMToken()!));
    if (!response.ok) return Promise.resolve(undefined);
    return await response.json();
}

const buildStatsURL = (timeRange: TimeRange, start: number | undefined, end: number | undefined, useUserAgnosticStats: boolean): string => {
    const username = useUserAgnosticStats ? 'null' : localStorage.getItem('username');
    return BACKEND_URL + '/api/stats/' + username + '/' + timeRangeToURLString(timeRange, start, end);
}

const buildEntityStatsURL = (id: string, entityType: string) => {
    return BACKEND_URL + '/api/' + entityType + 'Stats/' + localStorage.getItem('username') + '/' + id;
};

const buildSearchURL = (searchTerm: string): string => {
    return BACKEND_URL + '/api/search/' + localStorage.getItem('username') + '/' + searchTerm;
}

const timeRangeToURLString = (timeRange: TimeRange, start: number | undefined, end: number | undefined): string => {
    if (timeRange === TimeRange.AllTime) return 'allTime';
    if (timeRange === TimeRange.Last7Days) return 'last7';
    if (timeRange === TimeRange.Last30Days) return 'last30';
    if (timeRange === TimeRange.YTD) return 'ytd';
    return (start ?? 0) + '-' + (end ?? Date.now()); // TimeRange.Custom
}